class HHBlogFilters extends HTMLElement {
  constructor() {
    super()

    this.filterData = []
  }

  connectedCallback() {
    this.bindClickButtonEvents()
  }

  bindClickButtonEvents () {
    this.querySelectorAll('.js-filter-item').forEach(filter => {
      filter.addEventListener('click', this.handleFilterClick.bind(this))
    })
  }

  handleFilterClick (event) {
    event.preventDefault()

    history.pushState(
      null,
      '',
      event.target.href
    )

     this.querySelectorAll('.js-filter-item').forEach(filter => {
        filter.classList[filter.isSameNode(event.target.closest('.js-filter-item')) ? 'add' : 'remove']('filter__single--active')
     })

    this.renderPage(event)
  }

  renderPage (event) {
   const url =
      `${event.target.href}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&')

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl)
      : this.renderSectionFromFetch(url)
  }

  renderSectionFromCache (filterDataUrl) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderBlogsGrid(html)
  }

  renderSectionFromFetch (url) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')

        this.filterData = [...this.filterData, { html, url }]
        this.renderBlogsGrid(html)
      })
  }

  renderBlogsGrid (html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('main-blog').innerHTML

    document.getElementById('main-blog').innerHTML = innerHTML
  }

  getSections () {
    return [
      {
        id: 'main-blog',
        section: document.getElementById('main-blog').dataset.id,
      }
    ]
  }
}

customElements.define('hh-blog-filters', HHBlogFilters)
